import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Headphones } from "lucide-react";

export default function Auth() {
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login, register } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = mode === "login" ? await login(form.email, form.password) : await register(form.name, form.email, form.password);
      toast.success("Accesso effettuato");
      nav(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore");
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[calc(100vh-5rem)] flex items-center justify-center px-4 py-16 bg-slate-50">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-slate-100 p-8">
        <div className="flex justify-center mb-6"><span className="w-12 h-12 rounded-xl bg-navy flex items-center justify-center"><Headphones className="w-6 h-6 text-gold" /></span></div>
        <h1 className="font-serif text-3xl font-bold text-navy text-center mb-2">{mode === "login" ? "Bentornato" : "Crea il tuo account"}</h1>
        <p className="text-center text-slate-500 mb-8">{mode === "login" ? "Accedi per continuare ad ascoltare" : "Registrati per accedere ai contenuti"}</p>

        <button onClick={googleLogin} data-testid="google-login-button" className="w-full flex items-center justify-center gap-3 border border-slate-200 rounded-full py-3 font-medium text-slate-700 hover:bg-slate-50 transition-colors mb-4">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" /> Continua con Google
        </button>
        <div className="flex items-center gap-3 my-4"><div className="flex-1 h-px bg-slate-200" /><span className="text-xs text-slate-400">oppure</span><div className="flex-1 h-px bg-slate-200" /></div>

        <form onSubmit={submit} className="space-y-4">
          {mode === "register" && (
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome e cognome" data-testid="auth-name" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy" />
          )}
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="auth-email" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy" />
          <input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password" data-testid="auth-password" className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:outline-none focus:border-navy" />
          <button type="submit" disabled={loading} data-testid="auth-submit" className="w-full bg-navy text-white rounded-full py-3.5 font-medium hover:bg-petrol transition-all disabled:opacity-60">
            {loading ? "Attendere..." : mode === "login" ? "Accedi" : "Registrati"}
          </button>
        </form>

        <p className="text-center text-sm text-slate-500 mt-6">
          {mode === "login" ? "Non hai un account?" : "Hai già un account?"}{" "}
          <button onClick={() => setMode(mode === "login" ? "register" : "login")} data-testid="auth-toggle" className="text-navy font-semibold hover:text-gold">
            {mode === "login" ? "Registrati" : "Accedi"}
          </button>
        </p>
      </div>
    </div>
  );
}
